import { useState, useEffect } from "react";

/**
 * Custom hook to manage form data stored in localStorage.
 * @returns {{
 *   formData: object | null;
 *   loading: boolean;
 *   error: string | null;
 *   clearFormData: () => void;
 * }}
 */
function useFormData() {
  const [formData, setFormData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);
    try {
      const savedData = localStorage.getItem("formData");
      const parsedData = savedData ? JSON.parse(savedData) : null;
      setFormData(parsedData);
    } catch (err) {
      console.error("Error retrieving form data from localStorage:", err);
      setError(
        "Failed to load your saved application data. Please try refreshing the page."
      );
    } finally {
      setLoading(false);
    }
  }, []);

  const clearFormData = () => {
    try {
      localStorage.removeItem("formData");
      setFormData(null); // Update state immediately
    } catch (err) {
      console.error("Error removing form data from localStorage:", err);
      setError(
        "Failed to clear saved application data. Please try refreshing the page."
      );
      // Optionally re-throw or handle more gracefully
    }
  };

  return { formData, loading, error, clearFormData };
}

export default useFormData;
